export default {
  namespaced: true,
  state: {
    sales: [],
    sale: null,
    categoriesList: [],
    productsList: [],
    coatingsList: [],
  },
  actions: {
    /** Получение списка продаж */
    GetSalesList({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'sales', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('sales/api/v3/sales/list', { ...payload })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'sales', value: response.data.sales });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    /** Получение деталей продажи */
    GetSale({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'sale', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('sales/api/v3/sales/view', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'sale', value: response.data.sale });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    /** Блок Добавления новой продажи */
    /** Получить список категорий */
    GetCategories({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'categoriesList', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('sales/api/v3/categories', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'categoriesList', value: response.data.categories });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    /** Получить список товаров */
    GetProducts({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'productsList', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('sales/api/v3/products', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'productsList', value: response.data.products });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    /** Получить список покрытий */
    GetСoatings({ commit, rootGetters, dispatch }, categoryId) {
      commit('setField', { name: 'coatingsList', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.get('sales/api/v3/coatings', { params: { categoryId } })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'coatingsList', value: response.data.coating });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    /** Расчет бонусов за товар */
    CalculatedBonuses({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.get('sales/api/v3/products/calculate-bonuses', { params: { ...payload } })
          .then((response) => {
            if (response && response.data) {
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    /** Добавление продажи */
    AddSale({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('sales/api/v3/sales/create', { ...payload })
          .then((response) => {
            if (response && response.data) {
              resolve(response.data);
              dispatch('ShowInfoMessage', 'Продажа добавлена', { root: true });
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetActionsList({ commit, dispatch, rootGetters }, payload) {
      commit('setField', { name: 'actions', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('actions/api/action/current-list', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'actions', value: response.data.actions });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetAction({ commit, rootGetters, dispatch }, payload) {
      dispatch('ClearAction');
      if (payload.noClearSale === undefined) {
        dispatch('ClearSale');
      }
      rootGetters.axl.post('actions/api/action/view', payload)
        .then((response) => {
          commit('setField', { name: 'action', value: response.data.action });
          commit('setField', { name: 'categories', value: response.data.action.categories });
          commit('setField', { name: 'groups', value: response.data.action.groups });
          commit('setField', { name: 'products', value: response.data.action.products });
        });
    },
    ClearAction({ commit }) {
      commit('setField', { name: 'action', value: null });
      commit('setField', { name: 'categories', value: [] });
      commit('setField', { name: 'groups', value: [] });
      commit('setField', { name: 'products', value: [] });
    },
    /** Добавление продажи */
    UpdateSale({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('sales/api/v3/sales/update', { ...payload })
          .then((response) => {
            if (response && response.data) {
              resolve(response.data);
              dispatch('ShowInfoMessage', 'Продажа обновлена', { root: true });
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    /** Удаление продажи */
    DeleteSale({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('sales/api/v3/sales/delete', { ...payload })
          .then((response) => {
            if (response && response.data) {
              resolve(response.data);
              dispatch('ShowInfoMessage', 'Продажа удалена', { root: true });
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreSales({ commit }) {
      commit('setField', { name: 'sales', value: [] });
      commit('setField', { name: 'sale', value: null });
      commit('setField', { name: 'categoriesList', value: [] });
      commit('setField', { name: 'productsList', value: [] });
      commit('setField', { name: 'coatingsList', value: [] });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
